/**
 * Type-aware content link (Spec 19 P7-B1). Videos go to the watch page; every
 * other content type goes to the article reader. Returns a plain string so
 * `<Link to={contentHref(...)}>` typechecks (TanStack accepts the string, the
 * clean-`tsc` pattern from Spec 15 confirm 2).
 */
export function contentHref(type: string, slug: string): string {
  return type === 'video' ? `/videos/${slug}` : `/articles/${slug}`;
}
